import Vue from "vue";
let vue = new Vue();

import { Message } from "element-ui";

import XLSX from "xlsx";

// 解析excel 返回数组 使用 fields 的版本
export async function resolvingXLSX(file, fields) {
  // debugger;
  let list = [];
  let data = await FunctionReadFile(file);
  // debugger;
  const workbook = XLSX.read(data.target.result, { type: "binary" });
  for (let sheet in workbook.Sheets) {
    const sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]);
    //若当前sheet没有数据，则continue
    if (sheetArray.length == 0) {
      continue;
    }
    // sheetArray是对象数组，每一行的数据是个对象
    // XLSX 直接将第一的数据当做对象的属性名
    for (let index in sheetArray) {
      //循环读取 每一行
      let rowTable = {};
      // debugger;
      for (let field in fields) {
        rowTable[field] =
          sheetArray[index][fields[field]] !== undefined
            ? sheetArray[index][fields[field]]
            : "";
      }
      list.push(rowTable);
    }
  }
  console.log("before reutrn list", list);
  return list;
}

function FunctionReadFile(file) {
  let fileReader = new FileReader();
  // debugger;
  return new Promise(function(resolve, reject) {
    fileReader.onload = e => {
      if (e.type === "load") {
        resolve(e);
      } else {
        reject(e);
      }
    };
    fileReader.readAsBinaryString(file);
  });
}

export function dealReturn(data, err) {
  // debugger;
  // console.log("data, err", data, err);
  if (data && data.data && data.data.meta && data.data.meta.status !== 200) {
    Message({
      type: "error",
      message: data.data.meta.msg
    });
  }
  if (data && data.data && !data.data.meta) {
    Message({
      type: "error",
      message: data.data
    });
  }
  // if (data && !data.data) {
  //   // 500
  //   Message({ type: "error", message: data.msg })
  // }

  if (!data && err && err.response) {
    // 500
    Message({ type: "error", message: err.response.data.message });
  }
  // 跨域没有response 超时
  if (!data && err && !err.response) {
    // 500
    Message({ type: "error", message: "请求超时" });
  }
  if (!data && !err) {
    Message({ type: "error", message: "请求没有任何返回" });
  }
}

// 判断是否勾选数据
export function _checkData(list) {
  if (list.length === 0) {
    Message({
      type: "error",
      message: "先勾选数据"
    });
    return false;
  }
  return true;
}

// 二级tableData 添加 checked 字段
export function _addProperyForTableData(list, property) {
  for (let item of list) {
    vue.$set(item, "checked", false);
    for (let i of item[property]) {
      vue.$set(i, "checked", false);
    }
  }
}

// 二级tableData 勾选 全部
/***
 * bool 是vue.checedkAll
 * list 是vue.tableData
 * childProperty 是二级数据的属性名
 * 因为childProperty 不同，不能使用mixins
 */
export function _checkAll(bool, list, childProperty) {
  for (let item of list) {
    item.checked = bool;
    for (let i of item[childProperty]) {
      i.checked = bool;
    }
  }
}
/**
 *
 * @param {*} ids vue.ids
 * @param {*} checkedList vue.checkedList
 */
export function _simpleCollectParam(ids, checkedList) {
  // for (let { child, parent } of checkedList) {
  //   ids.push(child.id)
  // }
  ids = checkedList.map(item => item.child.id);
}

// // 接口映射请求字段,
// /**
//  *
//  * @param {*} initParam 初始化 vue.param
//  * @param {*} currentParam vue.currentParam
//  * @param {*} checkedList vue.checkedList
//  */
// export function _collectParam(initParam, currentParam, checkedList) {
//   // vue.initParam();
//   initParam();
//   // let actionStatusApi = Desc.actionToApi(vue.actionStatus);
//   // let currentParam = vue.param[actionStatusApi];
//   // 使用计算属性替换上面两行代码,或者在 vue.actionStatus 的watch里计算
//   //

//   for (let { child, parent } of checkedList) {
//     // debugger;

//     for (let key in currentParam) {
//       let endOfS = Array.from(key).slice(-1)[0] === "s" ? true : false;
//       console.log("endOfS ", endOfS);
//       if (!child[key] && endOfS) {
//         let keyWithoutS = Array.from(key)
//           .slice(0, key.length - 1)
//           .join("");
//         if (
//           child[keyWithoutS] &&
//           currentParam[key] &&
//           currentParam[key].constructor === Array
//         ) {
//           currentParam[key].push(child[keyWithoutS]);
//         } else if (
//           !child[key] &&
//           child[keyWithoutS] &&
//           !currentParam[key]
//         ) {
//           currentParam[key] = child[keyWithoutS];
//         }
//       } else {
//         currentParam[key] = child[key] ? child[key] : undefined;
//       }
//     }
//   }

// }

export function submitBox(func, options, title, vm, pageVm) {
  const h = vue.$createElement;
  // let title = vue.actionList.filter(
  //   (item) => item.url === vue.actionStatus
  // )[0].title;

  vue
    .$msgbox({
      title: title,
      message: h("p", null, [
        h("span", null, "确定执行"),
        h("span", { style: "color: red" }, title),
        h("span", null, "操作")
      ]),
      showClose: false,
      showCancelButton: true,
      closeOnClickModal: false,
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
    .then(async () => {
      // 因为发请求不在 dialog.vue 但是 请求的状态和 dialog的loading 状态相关；
      // 只好调用dialog的方法；
      if (vm && vm.turnLoading) {
        vm.turnLoading(true);
      }
      let { data, err } = await func(options.api, options.param);
      if (vm && vm.turnLoading) {
        vm.turnLoading(false);
      }

      if (data && data.data.meta.status === 200) {
        vue.$notify({
          title: "提示",
          message: data.data.data,
          duration: 3000
        });
        // 请求成功 关闭弹窗；
        if (vm) {
          vm.hide();
        }
      } else {
        dealReturn(null, err);
      }
    })
    .finally(() => {
      pageVm.getTableData();
    });
}

export function collectApiParam(Desc, actionList) {
  // let list = [];
  let param = {};
  for (let item of actionList) {
    let item_api = actionToApi(item.url);
    let paramFormApi = Desc[item_api].param;

    if (paramFormApi) {
      param[item_api] = deepCloneWithoutValue(paramFormApi, true);
    }
  }
  return param;
}
export function actionToApi(action) {
  return action + "_api";
}

export function deepCloneWithoutValue(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "deepClone");
  }
  const targetObj = source.constructor === Array ? [] : {};

  Object.keys(source).forEach(keys => {
    if (source[keys] && source[keys].constructor === Array) {
      targetObj[keys] = [];
    } else if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepCloneWithoutValue(source[keys]);
    } else {
      targetObj[keys] = undefined;
    }
  });

  return targetObj;
}



// WEBPACK FOOTER //
// ./src/common/js/index.js